import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=a45a1c88&scoped=true"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&id=a45a1c88&prod&lang=less"
import style1 from "./ShowAnnouncement.vue?vue&type=style&index=1&id=a45a1c88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45a1c88",
  null
  
)

export default component.exports